import React from 'react';
import { Button, ModalDialog } from 'vetrf-ui';
import { ProductType } from 'components/registry/types/api';
import { FormContainer } from 'components/FormContainer';
import { EntryRegistrationDTO } from 'api/entryRegistration/types';
import { FormFields } from './FormFields';

type EditRegistrationModalProps = {
  defaultValues?: EntryRegistrationDTO;
  productType: ProductType;
  handleSubmit: (data: EntryRegistrationDTO) => void;
  onClose: () => void;
};

export const EditRegistrationModal = ({
  defaultValues,
  productType,
  handleSubmit,
  onClose,
}: EditRegistrationModalProps) => (
  <FormContainer
    formConfig={{ defaultValues }}
    onSubmit={(data) => handleSubmit(data as EntryRegistrationDTO)}
  >
    <ModalDialog
      header={
        defaultValues
          ? 'Редактирование регистрационного удостоверения'
          : 'Добавление регистрационного удостоверения'
      }
      onClose={onClose}
      footer={
        <>
          <Button
            type="submit"
            color="success"
            iconColor="white"
            iconSize={100}
            size="sm"
            text={defaultValues ? 'Сохранить' : 'Добавить'}
          />
          <Button
            color="grey"
            iconColor="white"
            iconSize={100}
            onClick={onClose}
            size="sm"
            text="Отменить"
          />
        </>
      }
    >
      <div>
        <FormFields productType={productType} defaultValues={defaultValues} />
      </div>
    </ModalDialog>
  </FormContainer>
);
